import * as React from "react"
import Svg, { SvgProps, Path, Mask } from "react-native-svg"
const MainHomeScreenIcon = (props: SvgProps) => (
  <Svg
    width={64}
    height={57}
    fill="none"
    {...props}
  >
    <Path
      fill="#C0A46F"
      fillRule="evenodd"
      d="M57.79 0c0 3.01-2.44 5.45-5.45 5.45h-.004v.001h.003a5.45 5.45 0 0 1 5.451 5.451h.001c0-2.985 2.4-5.41 5.375-5.45A5.451 5.451 0 0 1 57.791 0V0ZM3.61 46.69a3.609 3.609 0 0 1-3.608 3.608H0h.002a3.609 3.609 0 0 1 3.609 3.609h.001a3.609 3.609 0 0 1 3.556-3.609 3.609 3.609 0 0 1-3.556-3.608h-.001Z"
      clipRule="evenodd"
    />
    <Mask id="a" fill="#fff">
      <Path
        fillRule="evenodd"
        d="M5.164 30.348c14.71-.001 26.635-11.865 26.635-26.5 0 14.635 11.926 26.5 26.638 26.5-14.71 0-26.635 11.864-26.635 26.5H31.8c0-14.636-11.926-26.5-26.637-26.5Z"
        clipRule="evenodd"
      />
    </Mask>
    <Path
      fill="#C0A46F"
      d="M5.164 30.348v-1.5h-1.5v1.5h1.5ZM31.8 3.848v-1.5h-1.5v1.5h1.5Zm0 0h1.5v-1.5h-1.5v1.5Zm26.638 26.5v1.5-3 1.5Zm-26.635 26.5v1.5h1.5v-1.5h-1.5Zm-.001 0h-1.5v1.5h1.5v-1.5Zm-26.637-26.5h-1.5v1.5h1.5v-1.5Zm0 1.5c15.532-.001 28.135-12.53 28.135-28h-3c0 13.799-11.246 24.999-25.135 25v3ZM31.8 5.348v-3 3Zm-1.5-1.5h3-3Zm0 0c0 15.471 12.605 28 28.138 28v-3c-13.89 0-25.137-11.2-25.137-25h-3Zm28.138 28v-3 3Zm0-3c-15.531 0-28.135 12.529-28.135 28h3c0-13.8 11.246-25 25.136-25v-3Zm-26.635 26.5H31.8v3-3Zm-26.638-23.5c13.89 0 25.137 11.2 25.137 25h3c0-15.471-12.605-28-28.137-28v3Zm0 0v-3 3Zm1.5-1.5h-3 3Z"
      mask="url(#a)"
    />
  </Svg>
)
export default MainHomeScreenIcon
